var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("test", {
          attrs: { schemeId: _vm.schemeId },
          on: {
            "change-scheme": function($event) {
              _vm.schemeId = $event
            },
            loading: function($event) {
              _vm.loading = true
            },
            done: function($event) {
              return _vm.processResult($event)
            },
            result: function($event) {
              return _vm.processResult($event)
            }
          }
        }),
        _vm._v(" "),
        _c("test-result", {
          attrs: { loading: _vm.loading },
          model: {
            value: _vm.result,
            callback: function($$v) {
              _vm.result = $$v
            },
            expression: "result"
          }
        }),
        _vm._v(" "),
        _c("logs", { ref: "logs" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }